import React, { useEffect, useState } from "react";
import "./Popup.css";
import { ReservationMarketSegmentApi } from "../../../../Services/Service";
import { useProperty } from "../../../../PropertyContext";

const MarketPopup = ({ show, onClose, onSelect }) => {
  const { selectedProperty } = useProperty();
  const [marketSegment, setMarketSegment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const FetchMArketSegment = async () => {
      setLoading(true);
      try {
        const result = await ReservationMarketSegmentApi(
          selectedProperty?.PropertyID,
        );
        if (Array.isArray(result)) setMarketSegment(result);
      } catch (error) {
        console.log("error fetching market segment", error);
      } finally {
        setLoading(false);
      }
    };
    FetchMArketSegment();
  }, [selectedProperty]);

  useEffect(() => {
    if (!show) return undefined;
    setSearchText("");
    setSelectedId(null);

    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose]);

  if (!show) return null;

  const searchValue = searchText.replace(/\*/g, "").trim().toLowerCase();
  const filteredMarkets = marketSegment.filter((market) =>
    `${market.Code} ${market.MarketSeg}`.toLowerCase().includes(searchValue),
  );
  const selectedMarket = marketSegment.find(
    (market) => market.ID === selectedId,
  );

  return (
    <div
      id="marketPopupBackdrop"
      className="bon-lookup-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        id="marketPopup"
        className="modal-dialog modal-dialog-centered bon-lookup-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="marketPopupTitle"
      >
        <div className="modal-content">
          <div className="modal-header bon-lookup-header">
            <h5 id="marketPopupTitle" className="modal-title">
              Search and Select Market
            </h5>
            <button
              type="button"
              className="btn-close bon-popup-close"
              aria-label="Close market popup"
              onClick={onClose}
            />
          </div>

          <div className="modal-body">
            <div className="input-group bon-popup-search">
              <input
                id="marketSearchInput"
                type="search"
                className="form-control"
                placeholder="Use (*) for wildcard search"
                value={searchText}
                onChange={(event) => setSearchText(event.target.value)}
                autoFocus
              />
              <button type="button" className="btn bon-search-button">
                Search
              </button>
            </div>

            <div className="table-responsive bon-popup-table-wrap">
              <table className="table table-sm table-hover mb-0 bon-popup-table">
                <thead>
                  <tr>
                    <th scope="col">Code</th>
                    <th scope="col">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="2" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : (
                    <>
                      {filteredMarkets.map((market) => (
                        <tr
                          id={`market-row-${market.ID}`}
                          key={market.ID}
                          className={
                            selectedId === market.ID ? "bon-row-selected" : ""
                          }
                          onClick={() => setSelectedId(market.ID)}
                          onDoubleClick={() => onSelect(market)}
                        >
                          <td>{market.Code}</td>
                          <td>{market.MarketSeg}</td>
                        </tr>
                      ))}
                      {!filteredMarkets.length && (
                        <tr>
                          <td colSpan="2" className="text-center py-4">
                            No matching market found.
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer bon-lookup-footer">
            <button
              type="button"
              className="btn bon-cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              id="selectMarketButton"
              type="button"
              className="btn bon-select-button"
              disabled={!selectedMarket}
              onClick={() => onSelect(selectedMarket)}
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketPopup;
